(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["np-hero"] && !Shopify.designMode) return;
  try {
    
class NpRandomInterior extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    this.options = Array.from(this.querySelectorAll('template[data-np-interior-id]'));
    this.rotate();
    window.addEventListener('pageshow', event => {
      if (event.persisted) this.rotate();
    }, { signal: this.controller.signal });
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
  }
  rotate() {
    const display = this.querySelector('[data-np-interior-display]');
    if (!display || !this.options?.length) return;
    const ids = this.options.map(option => option.dataset.npInteriorId);
    let state = { seen: [], last: this.last || '' };
    try {
      const saved = JSON.parse(localStorage.getItem(this.dataset.storageKey) || 'null');
      if (saved && Array.isArray(saved.seen)) state = saved;
    } catch {}
    let choices = ids.filter(id => !state.seen.includes(id) && id !== state.last);
    if (!choices.length) {
      state.seen = [];
      choices = ids.filter(id => id !== state.last);
    }
    if (!choices.length) choices = ids;
    const selected = choices[Math.floor(Math.random() * choices.length)];
    const template = this.options.find(option => option.dataset.npInteriorId === selected);
    display.replaceChildren(template.content.cloneNode(true));
    this.last = selected;
    this.dataset.selectedImage = selected;
    try {
      localStorage.setItem(this.dataset.storageKey, JSON.stringify({ seen: [...state.seen, selected], last: selected }));
    } catch {}
  }
}
if (!customElements.get('np-random-interior')) customElements.define('np-random-interior', NpRandomInterior);

  } catch(e) { console.error(e); }
})();
})();
